import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class StepStatus extends Vue {
  @Prop({ required: true })
  public isValid!: boolean;

  protected mounted() {
    
  }
}